export const POLICY_ACCEPTANCE_VERSION = '2026-07-07';

const policyAcceptanceKey = (role, account = {}) => {
  const accountKey = account.id || account.email || account.mobile || '';
  if (!role || !accountKey) return '';
  return `kalamanch_policy_acceptance:${role}:${accountKey}:${POLICY_ACCEPTANCE_VERSION}`;
};

export const accountHasPolicyAcceptance = (account = {}) =>
  Boolean(account.privacy_policy_accepted && account.terms_accepted && account.trust_safety_accepted);

export const hasLocalPolicyAcceptance = (role, account = {}) => {
  if (accountHasPolicyAcceptance(account)) return true;
  const key = policyAcceptanceKey(role, account);
  if (!key || typeof window === 'undefined') return false;
  return window.localStorage.getItem(key) === 'accepted';
};

export const markLocalPolicyAcceptance = (role, account = {}) => {
  const key = policyAcceptanceKey(role, account);
  if (!key || typeof window === 'undefined') return;
  window.localStorage.setItem(key, 'accepted');
};

export const withAcceptedPolicyFields = (account = {}) => ({
  ...account,
  privacy_policy_accepted: true,
  terms_accepted: true,
  trust_safety_accepted: true,
  policy_accepted_at: account.policy_accepted_at || new Date().toISOString(),
  policy_acceptance_version: account.policy_acceptance_version || POLICY_ACCEPTANCE_VERSION,
});
